import cloneDeep from 'lodash/cloneDeep';
import uuid from '@src/utils/uuid';
import sbFieldModel from '@src/utils/models/sbFieldModel';
import FieldStateEnum from '@src/utils/enums/fieldStateEnum';

export default {
  inject: {
    sbField: {
      default: () => cloneDeep(sbFieldModel),
    },
  },
  data: () => ({
    internalId: null,
    defaultField: cloneDeep(sbFieldModel),
    fieldKey: 'defaultField',
  }),
  computed: {
    attrs() {
      const attrs = cloneDeep(this.$attrs);
      // The internal field is used to set the value of the input.
      // This line makes sure that the internal field and the cound value are always insync.
      attrs.value = this[this.fieldKey].value = this.internalValue // eslint-disable-line
      return {
        ...attrs,
      };
    },
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  mounted() {
    this.setFieldKey();
    this.setId();
    this.setLabelFor(this.internalId);
  },
  methods: {
    setFieldState(state) {
      this[this.fieldKey].state = state;
    },
    setFieldValue(value) {
      this.setFieldState(FieldStateEnum.input);
      this[this.fieldKey].value = value;
    },
    handleBlur(e) {
      this.setFieldState(FieldStateEnum.blur);
      e.target.blur();
    },
    handleFocus(e) {
      this.setFieldState(FieldStateEnum.focus);
      e.target.focus();
    },
    focusInput(e) {
      e.currentTarget.querySelector('input').focus();
    },
    setId() {
      this.internalId = this.id || uuid();
    },
    setFieldKey() {
      this.fieldKey = 'sbField';
      this.defaultField = null;
      if (this.value === null) {
        this.$watch('sbField', (val) => {
          if (this.internalValue !== val.value) this.internalValue = val.value;
        }, { deep: true });
      }
    },
  },
};
